
export const useDropDowns = () => [
        {name: 'All time'},
        {name: 'Today'},
        {name: 'Past Week'},
        {name: '30 Days'},
        {name: '90 Days'},
        {name: '6 Months'},
        {name: '1 Year'},
    ]